const travelRequestHeaders = {
  RequestNo: 'Request No.',
  TravelDate: 'Travel Date',
  UserFullName: 'Employee Name',
  TravelDestination: 'Travel Destination',
  TravelPurpouse: 'Travel Purpose',
  Status: 'Status',
};

const renderStatusColors = {
  New: {
    backgroundColor: '#2196F31A',
    fontColor: '#2196F3',
    borderColor: '#2196F3',
    dotColor: '#2196F3',
  },
  'Request for Quotation': {
    backgroundColor: '#0096881A',
    fontColor: '#009688',
    borderColor: '#009688',
    dotColor: '#009688',
  },
  'Pending for Decision': {
    backgroundColor: '#FF98001A',
    fontColor: '#B54708',
    borderColor: '#FF9800',
    dotColor: '#B54708',
  },
  'Pending for Submission': {
    backgroundColor: '#42A5F51A',
    fontColor: '#42A5F5',
    borderColor: '#42A5F5',
    dotColor: '#42A5F5',
  },
  'Pending for Approval': {
    backgroundColor: '#8882821A',
    fontColor: '#424242',
    borderColor: '#888282',
    dotColor: '#424242',
  },
  'Awaiting HR Approval': {
    backgroundColor: '#67A1241A',
    fontColor: '#67A124',
    borderColor: '#67A124',
    dotColor: '#67A124',
  },
  'Pending for Booking': {
    backgroundColor: '#3F51B51A',
    fontColor: '#3F51B5',
    borderColor: '#3F51B5',
    dotColor: '#3F51B5',
  },
  'Booking Confirmed': {
    backgroundColor: '#3EA9421A',
    fontColor: '#3EA942',
    borderColor: '#3EA942',
    dotColor: '#3EA942',
  },
  'Booking Cancelled': {
    backgroundColor: '#F443361A',
    fontColor: '#F44336',
    borderColor: '#F44336',
    dotColor: '#F44336',
  },
  'Request for Rebooking': {
    backgroundColor: '#9C27B01A',
    fontColor: '#9C27B0',
    borderColor: '#9C27B0',
    dotColor: '#9C27B0',
  },
  'Request for Cancellation': {
    backgroundColor: '#E91E631A',
    borderColor: '#E91E63',
    fontColor: '#E91E63',
    dotColor: '#E91E63',
  },
  Rejected: {
    backgroundColor: '#D32F2F1A',
    fontColor: '#D32F2F',
    borderColor: '#D32F2F',
    dotColor: '#D32F2F',
  },
  'Travel Cancelled': {
    backgroundColor: '#FF57221A',
    fontColor: '#FF5722',
    borderColor: '#FF5722',
    dotColor: '#FF5722',
  },
};

const bookingCategoryOptions = ['New', 'Rebooking', 'Cancellation'];

export { travelRequestHeaders, bookingCategoryOptions, renderStatusColors };
